module.exports = "/_next/static/images/OgGrowthReport-3ff845d26ffa654fcb9ae3e68701e301.jpg";